module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/id_4-4c4e3b11229fa876b5f4c30c2657c412.jpg";